import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "@material-ui/core";
import moment from "moment";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import { InputTextarea } from "primereact/inputtextarea";
import { CommonConfig } from "CommonConfig";
import { Checkbox } from "primereact/checkbox";

const AddSalesOrder = (props) => {
  const [userId, setUserId] = useState("");
  const [salesOrderId, setSalesOrderId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [itemLength, setItemLength] = useState(0);
  const [discountConfig, setDiscountConfig] = useState("percentage");
  const [formData, setFormData] = useState({
    salesDate: new Date(),
    salesDateErr: false,
    salesDateErrText: "",
    salesOrderNo: "",
    salesOrderNoErr: false,
    salesOrderNoErrText: "",
    client: "",
    clientErr: false,
    clientErrText: "",
    gstin: "",
    remarks: "",
    totalAmountExcludingGST: 0,
    totalAmountIncludingGST: 0,
    isGst: true,
    performaInvoiceId: "", // selected performa invoice id
    performaInvoiceNo: "", // selected performa invoice id
    // New fields
    priority: "",
    priorityErr: false,
    priorityErrText: "",
    orderStatus: "Pending",
  });

  const [itemList, setItemList] = useState([
    {
      itemId: "",
      itemName: "",
      hsnCode: "",
      hsnCodeName: "",
      brandId: "",
      brandName: "",
      gst: 0,
      // 'price' will hold original base price (variant price - excl GST)
      price: 0,
      rateExcludingGST: 0,
      rateIncludingGST: 0,
      quantity: 0,
      unit: "",
      unitName: "",
      totalAmountIncludingGST: 0,
      remarks: "",
      barcode: "",
      mrp: 0,
      amount: 0,
      id: "",
      discount: 0,
      // new item-level fields
      producedQty: 0,
      remainingQty: 0,
    },
  ]);

  const [dropdownData, setDropdownData] = useState({
    client: [],
    product: [],
    hsnCode: [],
    brands: [],
    units: [],
    gstRates: [],
    performaInvoices: [],
    statusOptions: [
      { label: "Pending", value: "Pending" },
      { label: "Completed", value: "Completed" },
    ],
  });

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);

    // Load master data and config
    GetProductMaster(data);
    GetClientList(data);
    GetUnitMaster(data);
    GetBrandMaster(data);
    GetHSNCodeMaster(data);
    GetGSTMaster(data);
    GetConfigurationByConfigurationName(data);
    GenerateUniqueSalesOrderNo(data);
    FetchPerformaInvoiceList(data);

    // Check for Edit / View (passed via props.location.state)
    if (props.location?.state && props.location.state.SalesOrderId) {
      GetSalesOrderById(data, props.location.state.SalesOrderId);
      if (props.location.state.Type === "View") {
        setReadOnly(true);
      }
    }
  }, []);

  // ------------------- Master API calls -------------------
  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            product: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetClientList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Customer",
    };
    api
      .post(APIConstant.path.GetNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          setDropdownData((prevState) => ({
            ...prevState,
            client: filterArry,
          }));
        }
      })
      .catch(() => {});
  };

  const GetUnitMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            units: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetBrandMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            brands: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetHSNCodeMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetHSNCodeMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            hsnCode: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetGSTMaster = async (UserId) => {
    let params = {
      UserId: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            })
          );

          setDropdownData((prevState) => ({
            ...prevState,
            gstRates: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetConfigurationByConfigurationName = async (UserId) => {
    let params = {
      UserId: UserId,
      ConfigurationName: "Discount",
    };
    api
      .post(APIConstant.path.GetConfigurationByConfigurationName, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          if (response.Data) {
            setDiscountConfig(response.Data.ConfigurationValue);
          }
        }
      });
  };

  const GenerateUniqueSalesOrderNo = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GenerateUniqueSalesOrderNo, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          setFormData((prevState) => ({
            ...prevState,
            salesOrderNo: response.generatedID,
          }));
        }
      })
      .catch(() => {});
  };

  const FetchPerformaInvoiceList = async (UserId) => {
    // load performa invoices to show in dropdown (invoice no label, _id value)
    let params = { UserId, page: 0, limit: 1000 };
    api
      .post(APIConstant.path.GetPerformaInvoice, params)
      .then((res) => {
        if (res.Success === 1) {
          const options = (res.Data || []).map((inv) => ({
            label: inv.InvoiceNo,
            value: inv._id,
          }));
          setDropdownData((prev) => ({ ...prev, performaInvoices: options }));
        }
      })
      .catch(() => {});
  };

  // -------------------- Get SalesOrder for Edit/View --------------------
  const GetSalesOrderById = async (UserId, SalesOrderId) => {
    try {
      let params = {
        UserId,
        SalesOrderId,
      };
      api.post(APIConstant.path.GetSalesOrderById, params).then((response) => {
        if (response.Success === 1) {
          const data = response.Data;

          setFormData((prevState) => ({
            ...prevState,
            salesDate: data.SalesDate,
            salesOrderNo: data.SalesOrderNo,
            performaInvoiceId: data.PerformaInvoiceId,
            performaInvoiceNo: data.PerformaInvoiceNo,
            client: data.ClientId,
            clientName: data.ClientName,
            gstin: data.GSTIN,
            remarks: data.Remarks,
            totalAmountExcludingGST: data.TotalAmountExcludingGST || 0,
            totalAmountIncludingGST: data.TotalAmountIncludingGST || 0,
            isGst: data.IsGst,
            priority: data.Priority || "",
            orderStatus: data.OrderStatus || "Pending",
          }));

          let tempItemList = (data.ItemList || []).map((item) => {
            const produced = item.ProducedQty || item.ProducedQuantity || 0;
            const qty = Number(item.Quantity || 0);
            const remaining = Math.max(0, qty - produced);
            return {
              itemId: item.ItemId,
              itemName: item.ItemName,
              hsnCode: item.HSNCode,
              hsnCodeName: item.HSNCodeName,
              brandId: item.Brand,
              brandName: item.BrandName,
              gst: item.GST,
              price: item.RateExcludingGST,
              rateExcludingGST: item.RateExcludingGST,
              rateIncludingGST: item.RateIncludingGST,
              quantity: item.Quantity,
              originalUnit: item.OriginalUnitId,
              unit: item.UnitId,
              unitName: item.UnitName,
              totalAmountIncludingGST: item.TotalAmountIncludingGST,
              remarks: item.Remarks,
              barcode: item.Barcode,
              mrp: item.MRP,
              amount: item.Amount,
              discount: item.Discount,
              id: item?.id || item?._id || "",
              producedQty: produced,
              remainingQty: remaining,
            };
          });

          setSalesOrderId(data._id);
          setItemList(tempItemList.length ? tempItemList : itemList);
          setItemLength(tempItemList.length);
          updateTotals(tempItemList);
        } else {
          // not found or error
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  // -------------------- Save SalesOrder --------------------
  const AddSalesOrder = async () => {
    setLoading(true);
    if (!validate()) return setLoading(false);

    try {
      const payload = {
        SalesDate: formData.salesDate,
        SalesOrderNo: formData.salesOrderNo,
        PerformaInvoiceId: formData.performaInvoiceId,
        PerformaInvoiceNo: formData.performaInvoiceId
          ? dropdownData.performaInvoices.find(
              (pi) => pi.value === formData.performaInvoiceId
            )?.label
          : "",
        Client: formData.client,
        ClientName: dropdownData.client.find(
          (item) => item.value === formData.client
        )?.label,
        GSTIN: formData.gstin,
        Remarks: formData.remarks,
        TotalAmountExcludingGST: formData.totalAmountExcludingGST,
        TotalAmountIncludingGST: formData.totalAmountIncludingGST,
        ItemList: itemList.map((item) => {
          return {
            ItemId: item.itemId,
            ItemName: dropdownData.product.find(
              (obj) => obj.value === item.itemId
            )?.label,
            HSNCode: item.hsnCode,
            HSNCodeName: dropdownData.hsnCode.find(
              (obj) => obj.value === item.hsnCode
            )?.label,
            Brand: item.brandId,
            BrandName: dropdownData.brands.find(
              (obj) => obj.value === item.brandId
            )?.label,
            RateExcludingGST: item.rateExcludingGST,
            GST: item.gst,
            GSTName: dropdownData.gstRates.find((obj) => obj.value === item.gst)
              ?.label,
            RateIncludingGST: item.rateIncludingGST,
            Quantity: item.quantity,
            Discount: item.discount,
            UnitId: item.unit,
            UnitName: dropdownData.units.find((obj) => obj.value === item.unit)
              ?.label,
            OriginalUnitId: item.originalUnit,
            TotalAmountIncludingGST: item.totalAmountIncludingGST,
            Remarks: item.remarks,
            Barcode: item.barcode,
            MRP: item.mrp,
            Amount: item.amount,
            id: item.id,
            ProducedQty: item.producedQty || 0,
            RemainingQty: item.remainingQty || 0,
          };
        }),
        UserId: userId,
        SalesOrderId: salesOrderId,
        IsGst: formData?.isGst,
        // New fields
        Priority: formData.priority ? Number(formData.priority) : 0,
        OrderStatus: formData.orderStatus,
      };

      api.post(APIConstant.path.AddUpdateSalesOrder, payload).then((res) => {
        if (res.Success == 1) {
          setLoading(false);
          cogoToast.success(res.Message);
          props.history.push("/admin/sales-order");
        } else {
          setLoading(false);
          cogoToast.error(res.Message);
        }
      });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  // -------------------- Barcode -> Variant by barcode --------------------
  const GetVariantByBarcode = async (Barcode, index) => {
    let params = { UserId: userId, Barcode };
    api
      .post(APIConstant.path.GetVariantByBarcode, params)
      .then((response) => {
        if (response.Success === 1) {
          setItemList((prev) => {
            const updated = [...prev];
            let itemData = response.Data;

            updated[index].itemId = itemData.value;
            updated[index].hsnCode = itemData.HSNCode;
            updated[index].gst = itemData.GstRate;
            updated[index].brandId = itemData.Brand;
            updated[index].unit = itemData.UnitId;
            updated[index].originalUnit = itemData.UnitId;
            updated[index].amount = itemData.amount;
            if (itemData.Variant) {
              // store original base price in 'price'
              updated[index].price = itemData.Variant.Price || 0;
              updated[index].rateExcludingGST = itemData.Variant.Price || 0;
              updated[index].rateIncludingGST = itemData.Variant.Price
                ? Number(
                    (
                      itemData.Variant.Price +
                      (itemData.Variant.Price * itemData.GstRate) / 100
                    ).toFixed(2)
                  )
                : "";
              updated[index].priceIncluding = itemData.Variant.Price
                ? Number(
                    (
                      itemData.Variant.Price +
                      (itemData.Variant.Price * itemData.GstRate) / 100
                    ).toFixed(2)
                  )
                : "";
              // set MRP to original rate including GST (MRP remains unchanged by discount)
              updated[index].mrp = updated[index].rateIncludingGST || 0;
              // recalc amount fields with qty if present
              const qty = Number(updated[index].quantity) || 0;
              updated[index].amount = Number(
                (Number(updated[index].rateExcludingGST) * qty).toFixed(2)
              );
              updated[index].totalAmountIncludingGST = Number(
                (Number(updated[index].rateIncludingGST) * qty).toFixed(2)
              );
            }

            // ensure produced/remaining exist
            updated[index].producedQty = updated[index].producedQty || 0;
            const qtyNow = Number(updated[index].quantity || 0);
            updated[index].remainingQty = Math.max(
              0,
              qtyNow - Number(updated[index].producedQty || 0)
            );

            // update totals after variant selection
            updateTotals(updated);
            return updated;
          });
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch(() => {});
  };

  const validate = () => {
    let isValid = true;

    let updatedFormData = { ...formData };

    const formFieldsToValidate = [
      { key: "salesDate", label: "Date" },
      { key: "salesOrderNo", label: "Sales Order No" },
      { key: "client", label: "Client" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedFormData[key])) {
        isValid = false;
        updatedFormData[`${key}Err`] = true;
        updatedFormData[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedFormData[`${key}Err`] = false;
        updatedFormData[`${key}ErrText`] = "";
      }
    });

    setFormData(updatedFormData);

    let tempItems = [...itemList];

    tempItems = tempItems.map((item) => {
      const updatedItem = { ...item };

      const itemFields = [
        { key: "itemId", label: "Item" },
        { key: "unit", label: "Unit" },
      ];

      itemFields.forEach(({ key, label }) => {
        if (CommonConfig.isEmpty(item[key])) {
          isValid = false;
          updatedItem[`${key}Err`] = true;
          updatedItem[`${key}ErrText`] = `${label} is required`;
        } else {
          updatedItem[`${key}Err`] = false;
          updatedItem[`${key}ErrText`] = "";
        }
      });

      return updatedItem;
    });

    setItemList(tempItems);

    if (!itemList.length) {
      isValid = false;
      cogoToast.error("Please select items");
    }

    return isValid;
  };

  // -------------------- calculation helpers (same as Performa logic) --------------------
  const computeDiscountAmountFromValue = (referenceValue, discountValue) => {
    if (!discountValue) return 0;
    if (discountConfig === "percentage") {
      return (Number(referenceValue || 0) * Number(discountValue || 0)) / 100;
    }
    // 'value'
    return Number(discountValue || 0);
  };

  const recalcItem = (updated, idx) => {
    const isGst = formData.isGst;
    const gst = Number(updated[idx].gst || 0);
    const orig = Number(updated[idx].price) || 0; // original base price (excl GST)
    const discountValue = Number(updated[idx].discount) || 0;
    const discountType = discountConfig;

    if (isGst) {
      let discountedBase = orig;
      if (discountType === "percentage") {
        discountedBase = orig - (orig * discountValue) / 100;
      } else if (discountType === "value") {
        discountedBase = orig - discountValue;
      }
      if (discountedBase < 0) discountedBase = 0;

      updated[idx].rateExcludingGST = Number(discountedBase.toFixed(2));
      updated[idx].rateIncludingGST = Number(
        (discountedBase * (1 + gst / 100)).toFixed(2)
      );

      updated[idx].mrp = Number((orig * (1 + gst / 100)).toFixed(2));

      const qty = Number(updated[idx].quantity) || 0;
      updated[idx].amount = Number(
        (Number(updated[idx].rateExcludingGST) * qty).toFixed(2)
      );
      updated[idx].totalAmountIncludingGST = Number(
        (Number(updated[idx].rateIncludingGST) * qty).toFixed(2)
      );
    } else {
      let discounted = orig;
      if (discountType === "percentage") {
        discounted = orig - (orig * discountValue) / 100;
      } else {
        discounted = orig - discountValue;
      }
      if (discounted < 0) discounted = 0;

      updated[idx].rateExcludingGST = Number(discounted.toFixed(2));
      updated[idx].rateIncludingGST = 0;
      updated[idx].mrp = Number(orig.toFixed(2));

      const qty = Number(updated[idx].quantity) || 0;
      updated[idx].amount = Number((discounted * qty).toFixed(2));
      updated[idx].totalAmountIncludingGST = 0;
    }

    // keep produced/remaining in sync
    updated[idx].producedQty = updated[idx].producedQty || 0;
    const q = Number(updated[idx].quantity || 0);
    updated[idx].remainingQty = Math.max(
      0,
      q - Number(updated[idx].producedQty)
    );
  };

  const updateTotals = (updatedItems) => {
    if (!updatedItems || !updatedItems.length) {
      setFormData((prev) => ({
        ...prev,
        totalAmountExcludingGST: 0,
        totalAmountIncludingGST: 0,
      }));
      return;
    }

    const totalExcl = updatedItems.reduce(
      (acc, it) => acc + Number(it.amount || 0),
      0
    );
    const totalIncl = updatedItems.reduce(
      (acc, it) => acc + Number(it.totalAmountIncludingGST || 0),
      0
    );

    setFormData((prev) => ({
      ...prev,
      totalAmountExcludingGST: Number(totalExcl.toFixed(2)),
      totalAmountIncludingGST: Number(totalIncl.toFixed(2)),
    }));
  };

  // -------------------- main item change handler (keeps Performa logic intact) --------------------
  const handleItemListChange = (value, field, index, regex) => {
    if (!value && value !== 0) {
      setItemList((prev) => {
        const updated = [...prev];
        updated[index][field] = value;
        updated[index][`${field}Err`] = true;
        updated[index][`${field}ErrText`] = `This field is required`;
        if (field === "discount") {
          updated[index].discount = 0;
          recalcItem(updated, index);
        }
        updateTotals(updated);
        return updated;
      });
    } else {
      if (!regex || regex.test(value) || value === 0) {
        setItemList((prev) => {
          const updated = [...prev];
          if (field === "barcode") {
            value = value.toUpperCase();
          }
          updated[index][field] = value;
          updated[index][`${field}Err`] = false;
          updated[index][`${field}ErrText`] = "";

          if (field === "itemId") {
            let itemData = dropdownData.product.find(
              (item) => item.value === value
            );
            if (itemData) {
              updated[index].hsnCode = itemData.HSNCode;
              updated[index].gst = itemData.GstRate;
              updated[index].brandId = itemData.Brand;
              updated[index].unit = itemData.UnitId;
              updated[index].originalUnit = itemData.UnitId;

              if (itemData.Variant) {
                updated[index].price = Number(itemData.Variant.Price || 0);
                updated[index].rateExcludingGST = Number(
                  itemData.Variant.Price || 0
                );
                updated[index].rateIncludingGST = Number(
                  (
                    Number(itemData.Variant.Price || 0) +
                    (Number(itemData.Variant.Price || 0) *
                      Number(itemData.GstRate || 0)) /
                      100
                  ).toFixed(2)
                );
                updated[index].priceIncluding = updated[index].rateIncludingGST;
                updated[index].mrp = updated[index].rateIncludingGST || 0;
                const qty = Number(updated[index].quantity || 0);
                updated[index].amount = Number(
                  (Number(updated[index].rateExcludingGST || 0) * qty).toFixed(
                    2
                  )
                );
                updated[index].totalAmountIncludingGST = Number(
                  (Number(updated[index].rateIncludingGST || 0) * qty).toFixed(
                    2
                  )
                );
              }
            }
          } else if (field === "quantity") {
            updated[index].quantity = Number(value || 0);
            const qty = Number(updated[index].quantity || 0);
            updated[index].amount = Number(
              (Number(updated[index].rateExcludingGST || 0) * qty).toFixed(2)
            );
            updated[index].totalAmountIncludingGST = formData.isGst
              ? Number(
                  (Number(updated[index].rateIncludingGST || 0) * qty).toFixed(
                    2
                  )
                )
              : 0;
          } else if (field === "discount") {
            updated[index].discount = Number(value || 0);
            recalcItem(updated, index);
          } else if (field === "gst") {
            updated[index].gst = Number(value || 0);
            if (Number(updated[index].rateExcludingGST || 0) > 0) {
              updated[index].rateIncludingGST = Number(
                (
                  Number(updated[index].rateExcludingGST || 0) *
                  (1 + Number(updated[index].gst || 0) / 100)
                ).toFixed(2)
              );
            } else if (Number(updated[index].price || 0) > 0) {
              recalcItem(updated, index);
            }
            const qty = Number(updated[index].quantity || 0);
            updated[index].amount = Number(
              (Number(updated[index].rateExcludingGST || 0) * qty).toFixed(2)
            );
            updated[index].totalAmountIncludingGST = Number(
              (updated[index].rateIncludingGST || 0) * qty
            );

            // MRP update rule: only update MRP if discount === 0
            if (Number(updated[index].discount || 0) === 0)
              updated[index].mrp = updated[index].rateIncludingGST;
          } else if (field === "rateExcludingGST") {
            const manualBase = Number(value || 0);
            updated[index].price = manualBase;
            updated[index].rateExcludingGST = Number(manualBase.toFixed(2));
            const gstRate = Number(updated[index].gst || 0);
            updated[index].rateIncludingGST = Number(
              (manualBase * (1 + gstRate / 100)).toFixed(2)
            );
            const qty = Number(updated[index].quantity || 0);
            updated[index].amount = Number(
              (updated[index].rateExcludingGST * qty).toFixed(2)
            );
            updated[index].totalAmountIncludingGST = Number(
              (updated[index].rateIncludingGST * qty).toFixed(2)
            );
            const discountVal = Number(updated[index].discount || 0);
            if (discountVal > 0) {
              const discountAbs = computeDiscountAmountFromValue(
                updated[index].rateIncludingGST,
                discountVal
              );
              updated[index].mrp = Number(
                (updated[index].rateIncludingGST + discountAbs).toFixed(2)
              );
            } else {
              updated[index].mrp = Number(
                updated[index].rateIncludingGST.toFixed(2)
              );
            }
          } else if (field === "rateIncludingGST") {
            const manualIncl = Number(value || 0);
            const gstRate = Number(updated[index].gst || 0);
            const derivedBase = gstRate
              ? manualIncl / (1 + gstRate / 100)
              : manualIncl;
            updated[index].price = Number(derivedBase.toFixed(2));
            updated[index].rateExcludingGST = Number(derivedBase.toFixed(2));
            updated[index].rateIncludingGST = Number(manualIncl.toFixed(2));
            const qty = Number(updated[index].quantity || 0);
            updated[index].amount = Number(
              (updated[index].rateExcludingGST * qty).toFixed(2)
            );
            updated[index].totalAmountIncludingGST = Number(
              (updated[index].rateIncludingGST * qty).toFixed(2)
            );
            const discountVal = Number(updated[index].discount || 0);
            if (discountVal > 0) {
              const discountAbs = computeDiscountAmountFromValue(
                manualIncl,
                discountVal
              );
              updated[index].mrp = Number(
                (manualIncl + discountAbs).toFixed(2)
              );
            } else {
              updated[index].mrp = Number(manualIncl.toFixed(2));
            }
          } else if (field === "mrp") {
            const newMrp = Number(value || 0);
            updated[index].mrp = Number(newMrp.toFixed(2));
            const discountVal = Number(updated[index].discount || 0);
            if (formData.isGst) {
              let discountAbs = 0;
              if (discountVal > 0)
                discountAbs = computeDiscountAmountFromValue(
                  newMrp,
                  discountVal
                );
              const rateIncl = Number((newMrp - discountAbs).toFixed(2));
              const gstRate = Number(updated[index].gst || 0);
              const rateExcl = gstRate
                ? Number((rateIncl / (1 + gstRate / 100)).toFixed(2))
                : rateIncl;
              updated[index].rateIncludingGST = rateIncl;
              updated[index].rateExcludingGST = rateExcl;
              updated[index].price = Number(rateExcl.toFixed(2));
              const qty = Number(updated[index].quantity || 0);
              updated[index].amount = Number((rateExcl * qty).toFixed(2));
              updated[index].totalAmountIncludingGST = Number(
                (rateIncl * qty).toFixed(2)
              );
            } else {
              let discountAbs = 0;
              if (discountVal > 0)
                discountAbs = computeDiscountAmountFromValue(
                  newMrp,
                  discountVal
                );
              const rate = Number((newMrp - discountAbs).toFixed(2));
              updated[index].rateExcludingGST = rate;
              updated[index].price = rate;
              updated[index].rateIncludingGST = 0;
              updated[index].totalAmountIncludingGST = 0;
              const qty = Number(updated[index].quantity || 0);
              updated[index].amount = Number((rate * qty).toFixed(2));
            }
          } else {
            // other fields (barcode, remarks...) simply set
          }

          updateTotals(updated);
          return updated;
        });
      }
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Enter") {
      try {
        if (itemList[idx].barcode) {
          GetVariantByBarcode(itemList[idx].barcode, idx);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // -------------------- Add / Remove items --------------------
  const addItem = () => {
    setItemLength((prev) => prev + 1);
    setItemList((prev) => [
      ...prev,
      {
        itemId: "",
        itemName: "",
        hsnCode: "",
        hsnCodeName: "",
        brandId: "",
        brandName: "",
        gst: 0,
        price: 0,
        rateExcludingGST: 0,
        rateIncludingGST: 0,
        quantity: 0,
        unit: "",
        unitName: "",
        totalAmountIncludingGST: 0,
        remarks: "",
        barcode: "",
        mrp: 0,
        amount: 0,
        id: "",
        discount: 0,
        producedQty: 0,
        remainingQty: 0,
      },
    ]);
  };

  const removeItem = (index) => {
    setItemList((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      updateTotals(updated);
      return updated;
    });
  };

  // -------------------- Performa Invoice selection (Option C: copy all except SalesDate & SalesOrderNo) --------------------
  const onSelectPerformaInvoice = async (value) => {
    if (!value) return;
    try {
      const params = { UserId: userId, InvoiceId: value };
      const res = await api.post(
        APIConstant.path.GetPerformaInvoiceById,
        params
      );
      if (res.Success === 1 && res.Data) {
        const inv = res.Data;

        // copy everything except SalesDate and SalesOrderNo
        setFormData((prev) => ({
          ...prev,
          performaInvoiceId: value,
          client: inv.ClientId,
          clientName: inv.ClientName,
          gstin: inv.GSTIN,
          remarks: inv.Remarks,
          isGst: inv.IsGst,
          totalAmountExcludingGST: inv.TotalAmountExcludingGST || 0,
          totalAmountIncludingGST: inv.TotalAmountIncludingGST || 0,
          // SALES DATE & SALES ORDER NO stay unchanged (salesDate default / generated)
        }));

        // map item list exactly (editable)
        const items = (inv.ItemList || []).map((it) => {
          const produced = it.ProducedQty || it.ProducedQuantity || 0;
          const qty = Number(it.Quantity || 0);
          return {
            itemId: it.ItemId,
            itemName: it.ItemName,
            hsnCode: it.HSNCode,
            hsnCodeName: it.HSNCodeName,
            brandId: it.Brand,
            brandName: it.BrandName,
            gst: it.GST,
            price: it.RateExcludingGST,
            rateExcludingGST: it.RateExcludingGST,
            rateIncludingGST: it.RateIncludingGST,
            quantity: it.Quantity,
            originalUnit: it.OriginalUnitId,
            unit: it.UnitId,
            unitName: it.UnitName,
            totalAmountIncludingGST: it.TotalAmountIncludingGST,
            remarks: it.Remarks,
            barcode: it.Barcode,
            mrp: it.MRP,
            amount: it.Amount,
            discount: it.Discount,
            id: it.id || it._id || "",
            producedQty: produced,
            remainingQty: Math.max(0, qty - produced),
          };
        });

        setItemList(items.length ? items : itemList);
        setItemLength(items.length);
        updateTotals(items);
      } else {
        cogoToast.error(res.Message || "Performa not found");
      }
    } catch (err) {
      console.error(err);
    }
  };

  // -------------------- Form-level change handler --------------------
  const handleFormChange = (value, field, regex) => {
    if (field === "isGst") {
      const newIsGst = !!value;
      setFormData((prev) => ({
        ...prev,
        isGst: newIsGst,
      }));

      // Preserve existing values while toggling behavior (do not zero-out)
      setItemList((prev) => {
        const updated = prev.map((it) => {
          const copy = { ...it };
          if (!newIsGst) {
            // GST -> non GST conversion rule (Option A from previous dialog)
            const finalRate = Number(
              copy.rateIncludingGST || copy.rateExcludingGST || copy.price || 0
            );
            copy.rateExcludingGST = finalRate;
            copy.rateIncludingGST = 0;
            copy.gst = 0;
            copy.totalAmountIncludingGST = 0;
            copy.mrp = finalRate;
            const qty = Number(copy.quantity || 0);
            copy.amount = Number((finalRate * qty).toFixed(2));
          } else {
            // Non-GST -> GST conversion: treat existing rate as rateExcludingGST
            const rateExcl = Number(
              copy.rateExcludingGST || copy.mrp || copy.price || 0
            );
            const gstRate = Number(copy.gst || 0);
            copy.rateExcludingGST = rateExcl;
            copy.rateIncludingGST = Number(
              (rateExcl * (1 + gstRate / 100)).toFixed(2)
            );
            copy.mrp = copy.rateIncludingGST;
            const qty = Number(copy.quantity || 0);
            copy.amount = Number((rateExcl * qty).toFixed(2));
            copy.totalAmountIncludingGST = Number(
              (copy.rateIncludingGST * qty).toFixed(2)
            );
          }
          return copy;
        });
        updateTotals(updated);
        return updated;
      });

      return;
    }

    if (!value && value !== 0) {
      setFormData((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        setFormData((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
        }));
      }
    }
  };

  // -------------------- UI / button handlers, add/remove done above --------------------

  // -------------------- Render UI (mirrors AddPerformaInvoice.js structure) --------------------
  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard e-inward-body">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div
          className="ship-heading-area p-d-flex p-ai-center"
          onClick={() => {
            props.history.push("/admin/sales-order");
          }}
        >
          <i className="pi pi-arrow-right rotate" />
          <h2>Sales Order</h2>
        </div>
      </div>
      <hr />
      <div className="container-body e-container-body">
        <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
          <div className="p-grid">
            {/* GST checkbox */}
            <div className="p-sm-12 p-md-3 p-mt-1">
              <div className="p-d-flex p-ai-center p-mt-4">
                <div className="flex align-items-center">
                  <Checkbox
                    inputId="apply"
                    name="isGst"
                    onChange={(e) => handleFormChange(e.checked, "isGst")}
                    checked={formData.isGst}
                  />
                  <label htmlFor="apply" className="p-ml-2">
                    GST
                  </label>
                </div>
              </div>
            </div>

            {/* Sales Date */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Sales Date</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.salesDate
                        ? moment(formData.salesDate).format("DD/MM/YYYY")
                        : ""}
                    </p>
                  ) : (
                    <>
                      <div>
                        <Calendar
                          value={
                            formData.salesDate
                              ? new Date(formData.salesDate)
                              : new Date()
                          }
                          onChange={(e) =>
                            handleFormChange(e.value, "salesDate")
                          }
                          dateFormat="dd/mm/yy"
                          showIcon={false}
                          placeholder="Select Date"
                          className="p-w-100"
                          autoFocus
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.salesDateErr
                          ? formData.salesDateErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* SalesOrderNo - auto generated */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Sales Order No</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.salesOrderNo}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.salesOrderNo}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "salesOrderNo")
                          }
                          maxLength={30}
                          placeholder="Sales Order No"
                          className="p-w-100 e-input-common"
                          disabled
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.salesOrderNoErr
                          ? formData.salesOrderNoErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Performa Invoice dropdown */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Performa Invoice</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.performaInvoiceNo}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.performaInvoices}
                          value={formData.performaInvoiceId}
                          onChange={(e) => {
                            handleFormChange(e.value, "performaInvoiceId");
                            onSelectPerformaInvoice(e.value);
                          }}
                          placeholder="Select Performa Invoice"
                          className="p-w-100"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Client */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Client Name</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.clientName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.client}
                          value={formData.client}
                          onChange={(e) => handleFormChange(e.value, "client")}
                          placeholder="Client"
                          className="p-w-100"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.clientErr ? formData.clientErrText : null}{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* OrderStatus dropdown */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Status</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.orderStatus}</p>
                  ) : (
                    <Dropdown
                      filter
                      options={dropdownData.statusOptions}
                      value={formData.orderStatus}
                      onChange={(e) => handleFormChange(e.value, "orderStatus")}
                      placeholder="Status"
                      className="p-w-100"
                    />
                  )}
                </div>
              </div>
            </div>

            {/* Priority input */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Priority</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.priority}</p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          value={formData.priority}
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "priority",
                              /^\d{0,5}$/i
                            )
                          }
                          maxLength={5}
                          placeholder="Priority"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.priorityErr ? formData.priorityErrText : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* GSTIN */}
            {formData.isGst ? (
              <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">GSTIN</p>
                    {readOnly ? (
                      <p className="sub-text">{formData.gstin}</p>
                    ) : (
                      <>
                        <div>
                          <InputText
                            value={formData.gstin}
                            onChange={(e) =>
                              handleFormChange(
                                e.target.value,
                                "gstin",
                                /^[0-9A-Za-z]+$/i
                              )
                            }
                            maxLength={25}
                            placeholder="GSTIN"
                            className="p-w-100 e-input-common"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : null}

            {/* Total Amount Excl */}
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Total Amt (Excl. GST)</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.totalAmountExcludingGST}
                    </p>
                  ) : (
                    <>
                      <div>
                        <InputText
                          disabled
                          value={formData.totalAmountExcludingGST}
                          onChange={(e) =>
                            handleFormChange(
                              e.target.value,
                              "totalAmountExcludingGST",
                              /^\d+(\.\d{0,2})?$/i
                            )
                          }
                          maxLength={10}
                          placeholder="Amount excluding GST"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Total Amount Incl (if GST) */}
            {formData.isGst ? (
              <div className="p-sm-12 p-md-3">
                <div className="p-w-100 ">
                  <div className="custom-inputs e-order-mng order">
                    <p className="text p-mb-1">Total Amt (Incl. GST)</p>
                    {readOnly ? (
                      <p className="sub-text">
                        {formData.totalAmountIncludingGST}
                      </p>
                    ) : (
                      <>
                        <div>
                          <InputText
                            disabled
                            value={formData.totalAmountIncludingGST}
                            onChange={(e) =>
                              handleFormChange(
                                e.target.value,
                                "totalAmountIncludingGST",
                                /^\d+(\.\d{0,2})?$/i
                              )
                            }
                            maxLength={10}
                            placeholder="Amount including GST"
                            className="p-w-100 e-input-common"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : null}

            {/* remarks */}
            <div className="p-sm-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Remarks</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.remarks}</p>
                  ) : (
                    <InputTextarea
                      className="p-w-100"
                      value={formData.remarks}
                      onChange={(e) =>
                        handleFormChange(e.target.value, "remarks")
                      }
                      maxLength={200}
                      placeholder="Remarks"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ITEM LIST - entire item UI is same as AddPerformaInvoice */}
          {itemList?.map((item, vIdx) => (
            <div
              key={vIdx}
              className="item-section p-mb-3"
              style={{
                background: "#fff",
                borderRadius: "8px",
                border: "2px dotted #bdbdbd",
                width: "100%",
                marginBottom: "12px",
                position: "relative",
                boxSizing: "border-box",
                transition: "border 0.2s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  marginBottom: "18px",
                  minHeight: "48px",
                }}
              >
                <span
                  style={{
                    fontWeight: "600",
                    color: "#09090B",
                    fontSize: "1rem",
                    letterSpacing: "0.5px",
                  }}
                >
                  Item {vIdx + 1}
                </span>
                {!readOnly && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => removeItem(vIdx)}
                    style={{
                      minWidth: 120,
                      borderRadius: 8,
                      fontWeight: 500,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                      background: "#fff",
                    }}
                  >
                    <i className="pi pi-trash" style={{ marginRight: 8 }}></i>{" "}
                    Delete Item
                  </Button>
                )}
              </div>

              <div className="p-grid p-px-4">
                {/* Barcode */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Barcode</p>
                      {readOnly ? (
                        <p className="sub-text">{item.barcode}</p>
                      ) : (
                        <InputText
                          value={item.barcode}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "barcode",
                              vIdx
                            )
                          }
                          maxLength={50}
                          onKeyDown={(e) => handleKeyDown(e, vIdx)}
                          placeholder="Barcode"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Item Dropdown */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Raw Material/Item</p>
                      {readOnly ? (
                        <p className="sub-text">{item.itemName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.product}
                              value={item.itemId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "itemId", vIdx)
                              }
                              placeholder="Item"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.itemErr ? item.itemErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* HSN */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">HSN Code</p>
                      {readOnly ? (
                        <p className="sub-text">{item.hsnCodeName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.hsnCode}
                              value={item.hsnCode}
                              onChange={(e) =>
                                handleItemListChange(e.value, "hsnCode", vIdx)
                              }
                              placeholder="HSN Code"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.hsnCodeErr ? item.hsnCodeErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Brand */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Brand Name</p>
                      {readOnly ? (
                        <p className="sub-text">{item.brandName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.brands}
                              value={item.brandId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "brandId", vIdx)
                              }
                              placeholder="Brand Name"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.brandErr ? item.brandErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Quantity */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Quantity</p>
                      {readOnly ? (
                        <p className="sub-text">{item.quantity}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.quantity}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "quantity",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={10}
                              placeholder="Quantity"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.quantityErr ? item.quantityErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Unit */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Unit</p>
                      {readOnly ? (
                        <p className="sub-text">{item.unitName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.units}
                              value={item.unit}
                              onChange={(e) =>
                                handleItemListChange(e.value, "unit", vIdx)
                              }
                              placeholder="Unit"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.unitErr ? item.unitErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Produced Qty (disabled) */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Produced Qty</p>
                      {readOnly ? (
                        <p className="sub-text">{item.producedQty}</p>
                      ) : (
                        <InputText
                          disabled
                          value={item.producedQty || 0}
                          placeholder="Produced Qty"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Remaining Qty (disabled) */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Remaining Qty</p>
                      {readOnly ? (
                        <p className="sub-text">{item.remainingQty}</p>
                      ) : (
                        <InputText
                          disabled
                          value={Number(item.remainingQty || 0)}
                          placeholder="Remaining Qty"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Rate (Excl or Rate for non-GST) */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">
                        {formData.isGst ? "Rate (Excl. of GST)" : "Rate"}
                      </p>
                      {readOnly ? (
                        <p className="sub-text">{item.rateExcludingGST}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.rateExcludingGST}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "rateExcludingGST",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={15}
                              placeholder="Rate"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* GST fields for GST mode */}
                {formData.isGst ? (
                  <>
                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">GST %</p>
                          {readOnly ? (
                            <p className="sub-text">{item.gst}</p>
                          ) : (
                            <>
                              <div>
                                <Dropdown
                                  filter
                                  options={dropdownData.gstRates}
                                  value={item.gst}
                                  onChange={(e) =>
                                    handleItemListChange(e.value, "gst", vIdx)
                                  }
                                  placeholder="GST"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="p-sm-12 p-md-3">
                      <div className="p-w-100 ">
                        <div className="custom-inputs e-order-mng order">
                          <p className="text p-mb-1">Rate (Incl. of GST)</p>
                          {readOnly ? (
                            <p className="sub-text">{item.rateIncludingGST}</p>
                          ) : (
                            <>
                              <div>
                                <InputText
                                  value={item.rateIncludingGST}
                                  onChange={(e) =>
                                    handleItemListChange(
                                      e.target.value,
                                      "rateIncludingGST",
                                      vIdx,
                                      /^\d+(\.\d{0,2})?$/i
                                    )
                                  }
                                  maxLength={15}
                                  placeholder="Rate"
                                  className="p-w-100 e-input-common"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}

                {/* Total Amount (Incl GST) per item (disabled) */}
                {formData.isGst ? (
                  <div className="p-sm-12 p-md-3">
                    <div className="p-w-100 ">
                      <div className="custom-inputs e-order-mng order">
                        <p className="text p-mb-1">Total Amount (Incl. GST)</p>
                        {readOnly ? (
                          <p className="sub-text">
                            {item.totalAmountIncludingGST}
                          </p>
                        ) : (
                          <>
                            <div>
                              <InputText
                                disabled
                                value={item.totalAmountIncludingGST}
                                onChange={(e) =>
                                  handleItemListChange(
                                    e.target.value,
                                    "totalAmountIncludingGST",
                                    vIdx,
                                    /^\d+(\.\d{0,2})?$/i
                                  )
                                }
                                maxLength={15}
                                placeholder="Amount"
                                className="p-w-100 e-input-common"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* Discount */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Discount</p>
                      {readOnly ? (
                        <p className="sub-text">{item.discount}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.discount}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "discount",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={15}
                              placeholder="discount"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* MRP */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">MRP</p>
                      {readOnly ? (
                        <p className="sub-text">{item.mrp}</p>
                      ) : (
                        <InputText
                          value={item.mrp}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "mrp",
                              vIdx,
                              /^\d*$/i
                            )
                          }
                          maxLength={10}
                          placeholder="MRP"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Amount Excl GST (disabled) */}
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">
                        {formData.isGst
                          ? "Total Amount (Excl. GST)"
                          : "Total Amt"}
                      </p>
                      {readOnly ? (
                        <p className="sub-text">{item.amount}</p>
                      ) : (
                        <InputText
                          disabled
                          value={
                            Number(item?.rateExcludingGST || 0) *
                            Number(item?.quantity || 0)
                          }
                          onChange={(e) =>
                            handleItemListChange(e.target.value, "amount", vIdx)
                          }
                          maxLength={10}
                          placeholder="Amount"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Remarks */}
                <div className="p-sm-12">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Remarks</p>
                      {readOnly ? (
                        <p className="sub-text">{item.remarks}</p>
                      ) : (
                        <InputTextarea
                          className="p-w-100"
                          value={item.remarks}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "remarks",
                              vIdx
                            )
                          }
                          maxLength={200}
                          placeholder="Remarks"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {!readOnly && (
            <Button
              variant="outlined"
              color="primary"
              onClick={addItem}
              className="add-item-btn"
            >
              <i className="pi pi-plus" style={{ marginRight: 8 }}></i> Add Item
            </Button>
          )}
        </div>
      </div>

      <div className="p-d-flex p-ai-center p-jc-start e-inward-footer">
        <button
          className="secondary-btn"
          onClick={() => {
            props.history.push("/admin/sales-order");
          }}
        >
          Cancel
        </button>

        {readOnly ? null : (
          <Button
            className="primary-btn color-white p-ml-1"
            onClick={() => AddSalesOrder()}
            disabled={loading}
          >
            {loading ? "Submitting" : "Submit"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AddSalesOrder;
